module.exports = __webpack_public_path__ + "static/img/leiniao-benefit-vip_combo.f69ca0b3.png";